import React from 'react'
import './index.scss'

const PageContentTitle = props => (
  <h2 className="page-content-title">{props.children}</h2>
)

export default PageContentTitle



// WEBPACK FOOTER //
// ./src/components/page-content-title/index.js